module.exports = __webpack_public_path__ + "img/restaurant-cleanliness.3b56cefd.svg";